import { render, staticRenderFns } from "./PostalCodes.vue?vue&type=template&id=df78623a&scoped=true"
import script from "./PostalCodes.vue?vue&type=script&lang=js"
export * from "./PostalCodes.vue?vue&type=script&lang=js"
import style0 from "./PostalCodes.vue?vue&type=style&index=0&id=df78623a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df78623a",
  null
  
)

export default component.exports